// Company data is a large enough deal that the code for
// handling it is in the module
// Here is where the api calls are made, and the data is sent off to the store
// and the app is routed to where it needs to go.
import api from '@/api'
import store from '@/store'
import fromApi from '@/api/map-to-frontend'
import { successPipeline } from '@/api/pipelines/success-pipeline.js'
import { errorPipeline } from '@/api/pipelines/error-pipeline.js'

const getDefaultCompanyData = (jsConn) => {
  return api.getDefaultCompanyData(jsConn)
    .then(jsConn => {
      if (jsConn.apiCallStatus === 'success') {
        // send the data to the store
        jsConn.dataForStore = fromApi.defaultDataToStore(jsConn.response['data']['payload'])
        store.dispatch('loadCompanyData', jsConn.dataForStore)
        return Promise.resolve(jsConn)
      } else {
        return Promise.reject(jsConn)
      }
    })
}

const getUserCompanyData = (jsConn) => {
  return api.getUserCompanyData(jsConn)
    .then(jsConn => {
      if (jsConn.apiCallStatus === 'success') {
        // send the data to the store
        return successPipeline(jsConn)
      } else {
        return errorPipeline(jsConn)
      }
    })
    .then(jsConn => {
      jsConn.dataForStore = fromApi.defaultDataToStore(jsConn.response['data']['payload'])
      store.dispatch('loadCompanyData', jsConn.dataForStore)
      return Promise.resolve(jsConn)
    })
    .catch(jsConn => {
      return Promise.reject(jsConn)
    })
}

export { getDefaultCompanyData }
export { getUserCompanyData }
